import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import { CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

const AtlasSalesMarketShareProductSplineChart = () => {
  const { productEntity } = useProductEntity();
  return (
    <AtlasV2DorisSplineChart
      queryKey="MarketShareProductSplineChart"
      title="Market Share of Retail Sales"
      methodName="sales/GetSalesMetrics"
      metricTypeDisplay={METRICTYPE.PERCENT}
      metricType="retailSales"
      showMarketShare={true}
      splineChartProps={{ chartContextId: CHART_NAMES.SALES_MARKET_SHARE_PRODUCT_SPLINE }}
      marketShareRequestBuilder={(params) => {
        return {
          ...params,
          stacklineSkus: [],
          categoryIds: productEntity?.categoryIds
        };
      }}
    />
  );
};

export default AtlasSalesMarketShareProductSplineChart;
